import { IAddressBase } from '../../models/address';
import { IFeatureGroupBase } from '../../models/features';
import {
  IUserAssignmentBase,
  IUserBase,
  IUserOnboardBase,
  UserGender,
} from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateUserProps {
  address?: IAddressBase;
  userId: string;
  bio?: string;
  birthDate?: Date;
  categoriesId?: string[];
  cpf?: string;
  cnpj?: string;
  companyName?: string;
  email?: string;
  gender?: UserGender;
  featureGroupId?: string;
  healthCheck?: Date;
  name: string;
  foreignerDocument?: string;
  foreignerDocumentType?: string;
  useForeignerDocument?: boolean;
  phone?: string;
  tradeName?: string;
  venturesId?: string[];
}

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  venture?: IVentureBase;
}

export interface IUpdatedUser extends IUserBase {
  onboards: IUserOnboardBase[];
  userAssignments: IUserAssignment[];
}

export const updateUsersService = async ({
  address,
  bio,
  birthDate,
  categoriesId,
  cpf,
  cnpj,
  companyName,
  email,
  gender,
  featureGroupId,
  healthCheck,
  name,
  foreignerDocument,
  foreignerDocumentType,
  useForeignerDocument,
  phone,
  tradeName,
  venturesId,
  userId,
}: IUpdateUserProps): Promise<IUpdatedUser> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedUser>(
    `/v2/users/${userId}`,
    {
      address,
      bio,
      birthDate,
      categoriesId,
      cpf,
      cnpj,
      companyName,
      email,
      gender,
      featureGroupId,
      healthCheck,
      name,
      foreignerDocument,
      foreignerDocumentType,
      useForeignerDocument,
      phone,
      tradeName,
      venturesId,
    },
  );

  return data;
};
